import { render } from "./ContactListForMessages.vue?vue&type=template&id=bec7094c&scoped=true"
import script from "./ContactListForMessages.vue?vue&type=script&lang=js"
export * from "./ContactListForMessages.vue?vue&type=script&lang=js"

import "./ContactListForMessages.vue?vue&type=style&index=0&id=bec7094c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bec7094c"]])

export default __exports__